<template>
  <div>
    <div class="header-image">
      <img
        :src="require('@/assets/img/VM24_0997.jpg')"
        alt="Contact Porsche Auto Insurance"
      />
    </div>
    <section class="container">
      <div class="columns">
        <div
          class="column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop"
        >
          <h1 class="title">Frequently Asked Questions</h1>
          <p>
            Find answers to some of the most commonly asked questions. If you
            don’t see your question below, please
            <router-link to="/contact-us">Contact Us</router-link> and we will
            get back to you as soon as possible.
          </p>

          <div class="faq">
            <template v-for="(faq, index) in faq">
              <b-collapse
                v-bind:key="'collapse-' + index"
                :open.sync="faq.isOpen"
              >
                <div
                  :class="{
                    question: true,
                    'is-first': index === 0,
                    'is-active': faq.isOpen
                  }"
                  v-bind:key="'term-' + index"
                  slot="trigger"
                >
                  {{ faq.question }}
                  <span class="icon icon--arrow-down-hair"></span>
                </div>
                <div v-bind:key="'description-' + index">
                  <div class="answer" v-html="faq.answer"></div>
                </div>
                <div
                  v-bind:key="'description-' + index + '2'"
                  v-if="faq.image"
                  class="is-centered"
                >
                  <img
                    :src="require(`@/assets/img/${faq.image}`)"
                    v-html="faq.altText"
                  />
                </div>
                <div
                  v-bind:key="'description-' + index + '3'"
                  v-if="faq.hasForm"
                >
                  <AvailabilityForm isFaq="true"></AvailabilityForm>
                </div>
              </b-collapse>
            </template>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AvailabilityForm from '@/components/shared/AvailabilityForm';

export default {
  name: 'Faq',
  components: {
    AvailabilityForm
  },
  data() {
    return {
      faq: [
        {
          isOpen: false,
          question: 'What is Porsche Auto Insurance?',
          answer:
            'Porsche Auto Insurance is an innovative pay-per-mile insurance offering created specifically with Porsche drivers in mind. We offer tailored rates and exceptional service along with unmatched protection regarding mileage data collection.'
        },
        {
          isOpen: false,
          question: 'How does Porsche Auto Insurance work?',
          answer:
            'You pay for the miles you drive plus a monthly base rate. At each billing interval, you simply upload a photo of your odometer. Porsche Auto Insurance does the rest.<br><br>Our patented computer vision technology verifies the vehicle and the mileage from the photo sent. We then calculate your mileage, multiply it by your per-mile rate, and add it to your base rate. '
        },
        {
          isOpen: false,
          question: 'How are my rates calculated?',
          answer:
            'Each Porsche Auto Insurance policy includes two rates; a base rate that covers non-driving related risks (theft, fire, flood, etc.) and a per-mile rate that covers your vehicle while on the road. Both your base rate and your per-mile rate are determined using standard insurance variables like your age, credit history, driving history, garaging location, vehicle type, coverages and deductibles.'
        },
        {
          isOpen: false,
          question: 'What coverage do you offer?',
          answer:
            'Porsche Auto Insurance offers comprehensive and collision auto insurance policies with an A.M. Best "Excellent" rating and backing from a top-ranked national underwriting company. <a href = "/receive-a-quote">Click</a> or contact us at <a href="tel:1-' +
            this.$phoneNumber +
            '">' +
            this.$phoneNumber +
            '</a>  to receive a tailored quote today.'
        },
        {
          isOpen: false,
          question: 'Do you offer coverage for vehicles in storage?',
          answer:
            'Yes. Our innovative pricing allows you to store your Porsche vehicle and remain fully covered with a monthly base rate. When you’re ready to drive, simply continue with your base rate and pay for the miles you drive. No need to hassle updating your coverage.'
        },
        {
          isOpen: false,
          question: 'What kind of service can I expect?',
          answer:
            'When life happens, we get you back on the road and behind the wheel of your Porsche vehicle as quickly as possible. With Accident Assistance we tow your vehicle to the nearest qualified Porsche Approved Collision Center. Our network of Porsche Approved Collision Centers provides quality collision services and uses Porsche Genuine Parts. Our Claims Concierge is with you every step of the way during the claims process to answer any questions. While your Porsche is being repaired, we provide rental reimbursement on a high-end rental vehicle to drive until your repairs are complete. <sup> 1 </sup> <br><br> <span style = "font-size: 0.75rem"><sup>1</sup> Rental reimbursement up to $125 per day for a maximum of 30 days per vehicle repair </span>'
        },
        {
          isOpen: false,
          question: 'Where is Porsche Auto Insurance available?',
          answer:
            'Porsche Auto Insurance is currently available for Porsche vehicles garaged in Arizona, Florida, Georgia, Ohio, Oregon, Tennessee, and Texas.',
          image: 'availability.svg',
          altText:
            'A map of the United States indicating that Porsche Auto Insurance is currently available in Arizona, Florida, Georgia, Oregon, Tennessee, and Texas.'
        },
        {
          isOpen: false,
          question:
            'When will Porsche Auto Insurance be available in my state?',
          answer:
            'Porsche Auto Insurance will be expanding to more states in the near future. To find out when we are launching in your state, please provide your information below and we will stay in touch:',
          hasForm: true
        }
      ],
      isOpen: false
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin-bottom: 4rem;
  padding-top: 5rem;
  padding-bottom: 4rem;
}

.is-centered {
  text-align: center;
}

div.header-image {
  max-height: 100vh;
  overflow: clip;

  img {
    display: block;
    margin: 0;
    max-width: 100%;
    padding: 0;
  }
}
img {
  display: block;
  margin: 1rem auto;
  max-width: 75%;
}

img,
form {
  padding-bottom: 2rem;
}

.faq {
  border-bottom: 1px solid #f0f0f1;
  padding-top: 1rem;
}

.question {
  @include clearfix;
  border-top: 1px solid #f0f0f1;
  padding: 2rem 2rem 2rem 0;
  position: relative;

  &.is-first {
    border-top: 0;
  }

  .icon {
    color: $primary;
    font-weight: bold;
    font-size: 1.2rem;
    position: absolute;
    right: 0;
    margin-top: -0.75rem;
    top: 50%;
  }

  &.is-active {
    .icon {
      transform: rotate(-180deg);
    }
  }
}

.answer {
  padding-bottom: 2rem;
}

.title {
  text-align: center;
}
</style>
